export default __webpack_public_path__ + "static/media/gallery_01.a989a59c.jpg";